/**
 * Обрезает текст по словам, чтобы он поместился в заданное количество строк
 * @param text - Исходный текст
 * @param element - DOM-элемент для измерения высоты
 * @param maxLines - Максимальное количество строк
 * @returns Обрезанный текст или null, если обрезка не требуется
 */
export const truncateTextByWords = (text: string, element: HTMLElement, maxLines: number): string | null => {
    const lineHeight = parseInt(window.getComputedStyle(element).lineHeight);
    const maxHeight = lineHeight * maxLines;

    const tempElement = element.cloneNode() as HTMLElement;
    tempElement.style.position = 'absolute';
    tempElement.style.visibility = 'hidden';
    tempElement.style.width = `${element.offsetWidth}px`;
    element.parentElement?.appendChild(tempElement);

    tempElement.textContent = text;
    const needsTruncation = tempElement.scrollHeight > maxHeight;

    if (!needsTruncation) {
        element.parentElement?.removeChild(tempElement);

        return null;
    }

    const words = text.split(/\s+/);
    let lastValidText = '';

    for (let i = 0; i < words.length; i++) {
        const testText = words.slice(0, i + 1).join(' ');
        tempElement.textContent = testText;

        const currentHeight = tempElement.scrollHeight;

        if (currentHeight > maxHeight) {
            break;
        }

        if (currentHeight < maxHeight) {
            lastValidText = testText;
            continue;
        }

        const testWithEllipsis = testText + '.......';
        tempElement.textContent = testWithEllipsis;

        if (tempElement.scrollHeight <= maxHeight) {
            lastValidText = testText;
        } else {
            break;
        }
    }

    element.parentElement?.removeChild(tempElement);

    return lastValidText;
};
